// form actions
import axios from 'axios';

import { SET_FORMS, SET_FORMS_ERROR, SET_FORMS_LOADING } from './types';

export const fetchForms = () => async (dispatch) => {
	dispatch({ type: SET_FORMS_LOADING, payload: true });
	try {
		const res = await axios.get('/api/forms/get-all');
		const { data } = res;
		dispatch({ type: SET_FORMS, payload: data?.forms || [] });
		dispatch({ type: SET_FORMS_LOADING, payload: false });
		return data; // allow caller to use questions, etc.
	} catch (error) {
		dispatch({ type: SET_FORMS_ERROR, payload: 'Failed to load forms' });
		dispatch({ type: SET_FORMS_LOADING, payload: false });
		throw error;
	}
};
